import PaymentParametersAPI from "../../../api/PaymentParametersAPI";

export default {
  async paymentImport({commit}, data) {
    return await new PaymentParametersAPI().excelImport(data);
  }
};
